import { theme } from '@Guidelines/Theme/theme';
import formatLongDate from '@UI/Helpers/formatLongDate';
import type OrganizationWorkflowView from '@UI/Store/OrganizationWorkflows/Views/OrganizationWorkflowView';
import { css } from '@emotion/react';
import { Info } from 'lucide-react';
import type * as React from 'react';

const bannerStyle = css`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex-wrap: wrap;
	padding: 0.875rem 1.125rem;
	border-radius: ${theme.radii.large};
	background-color: ${theme.colors.accentSurface};
	color: ${theme.colors.accentDark};
`;

const textStyle = css`
	flex: 1;
	min-width: 15rem;
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: 0.84375rem;
	font-weight: ${theme.fontWeights.medium};
	line-height: 1.55;
`;

const versionStyle = css`
	font-family: ${theme.fonts.mono};
	font-size: ${theme.fontSizes.small};
	font-weight: ${theme.fontWeights.medium};
	line-height: 1.3;
`;

const describeVersion = (workflow: OrganizationWorkflowView | null): string => {
	if (workflow === null) {
		return 'Jamais publié';
	}

	return workflow.isActive
		? `Version ${workflow.version}, publiée le ${formatLongDate(workflow.publishedAt)}`
		: `Version ${workflow.version}, archivée`;
};

type Props = {
	/** Null for a group that was never published. */
	readonly workflow: OrganizationWorkflowView | null;
};

/** The notice that saving publishes a new version, with where the group stands. */
const VersionBanner: React.FC<Props> = ({ workflow }) => {
	return (
		<div css={bannerStyle}>
			<Info size={18} aria-hidden="true" />
			<p css={textStyle}>
				Enregistrer publie une nouvelle version. Les préparations déjà ouvertes gardent leur version.
			</p>
			<span css={versionStyle}>{describeVersion(workflow)}</span>
		</div>
	);
};

export default VersionBanner;
